import { render } from "./BlackList.vue?vue&type=template&id=65a9cb2b&scoped=true"
import script from "./BlackList.vue?vue&type=script&lang=js"
export * from "./BlackList.vue?vue&type=script&lang=js"

import "./BlackList.vue?vue&type=style&index=0&id=65a9cb2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a9cb2b"]])

export default __exports__